import { render, staticRenderFns } from "./GroupArchiveFilter.vue?vue&type=template&id=d2c55a92&"
import script from "./GroupArchiveFilter.vue?vue&type=script&lang=js&"
export * from "./GroupArchiveFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports